import React, { useState,useEffect } from "react";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import TagIcon from '@mui/icons-material/Tag';
import CallIcon from '@mui/icons-material/Call';
import TextField from "@mui/material/TextField";
import Accordion from "@mui/material/Accordion";
import EmailIcon from '@mui/icons-material/Email';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "../../../assets/styles/containers/_placeholder.scss";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { ArrowDown } from "../../../assets/svgIcons/Svg";
// import Signature from "../../../assets/images/Signature.svg";
import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { apiCall } from "../../utils/action";

const Placeholder = (props) => {
  const companyId = sessionStorage.getItem("company_id");
  const roleId = sessionStorage.getItem("role_id");
  const uuId = sessionStorage.getItem("user_id");
  const [placeholderValues, setPlaceHolderValues] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dataFiltered = filterData(searchQuery, placeholderValues);
  const inspectorDetails = [{ title: "Inspector Name", icon: <PersonIcon /> },
  // { title: "Inspector License", icon: <TagIcon /> }, { title: "Inspector Signature" }, 
  { title: "Inspector Phone", icon: <CallIcon /> }, { title: "Inspector Email", icon: <EmailIcon /> }]

  // const [placeholderValues, setPlaceHolderValues] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

const getPlaceHolderValues = () => {
    props.setShowLoader(true);
    const formdata = {
      company_id: companyId,
      user_id: uuId,
      role_id: roleId,
      agreement: props.isAgreementPlaceholder ? 1 : 0,
    };
    apiCall(
      (response) => {
        const { data, message, success } = response.data;
        if (success) {
          const hidden = ["Inspection Notes", "Inspection File Name"];
          setPlaceHolderValues(data.filter((d) => !hidden.includes(d.placeholder_key)));
          props.setShowLoader(false);
        } else {
          toast.error(message);
          props.setShowLoader(false);
          console.log("else ", response.data.message);
        }
      },
      formdata,
      "GET_AGREEMENT_PLACEHOLDERS"
    );
  };
  useEffect(() => {
    getPlaceHolderValues();
  }, []);
 
  function filterData(query, data) {
    if (!query) {
      return data;
    } else {
      return data.filter((d) => d.placeholder_key.toLowerCase().includes(query.toLowerCase()));
    }
  }
  const handleInsertPlaceholder = (placeholder) => {
    if (props.isAgreementPlaceholder) {
      const editorInstance = props.editor?.current?.editor;
 
      if (!editorInstance || !editorInstance.selection || !editorInstance.html) {
        toast.error("Froala editor is not ready.");
        console.warn("Froala editor instance or required APIs are missing.");
        return;
      }
 
      try {
        const cursorPosition = editorInstance.selection.get();
        if (cursorPosition) {
          editorInstance.events.focus(true);
          editorInstance.html.insert(` ${placeholder} `, true);
        } else {
          toast.error("Unable to find cursor position in Froala.");
        }
      } catch (err) {
        console.error("Froala error inserting placeholder:", err);
        toast.error("Failed to insert placeholder in Froala.");
      }
 
    } else {
      const editorInstance = props.editor?.current;
 
      if (!editorInstance || typeof editorInstance.insertHTML !== "function") {
        toast.error("Editor is not ready.");
        console.warn("SunEditor instance is not ready or insertHTML is missing.");
        return;
      }
 
      try {
        editorInstance.insertHTML(` ${placeholder} `);
      } catch (err) {
        console.error("SunEditor error inserting placeholder:", err);
        toast.error("Failed to insert placeholder in SunEditor.");
      }
    }
  };

  return (
    <div className="sticky-mergeField">
      <div className="placeholder-search">
        <TextField
          id="search-bar"
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          variant="outlined"
          placeholder="Search merge field"
          size="small"
        />
        <SearchIcon className="search-merge" />
      </div>
      <ul className="placeholder">
        {dataFiltered.length !== 0 ? (
          dataFiltered?.map((placeholder) => (
<Button className="placeholder-list" key={placeholder} onClick={() => handleInsertPlaceholder(placeholder.placeholder_value)}>
<span id={placeholder.placeholder_value} draggable="false">
<AddIcon /> {placeholder.placeholder_key}
</span>
</Button>
          ))
        ) : (
<li className="placeholder-list">
<p style={{ textAlign: "center" }}>No matches...</p>
</li>
        )}
</ul>
    </div>
  );
};

export default Placeholder;
